var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"v-app"}},[_c('v-header'),_c('div',{attrs:{"id":"about"}},[_c('v-about')],1),_c('div',{attrs:{"id":"topics"}},[_c('v-topics')],1),_c('div',{attrs:{"id":"review"}},[_c('v-review')],1),_c('v-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }